import { useCallback, useEffect } from "react";
import { ACCOUNT_LANGUAGE_EVENT, getAccountLanguage } from "./preferenceEvents";

/** Connect a department's existing translations to the saved staff preference. */
export function useStaffLanguageSync<T extends "en" | "ar">(
  setLocalLanguage: (value: T) => void,
) {
  useEffect(() => {
    const apply = (event: Event) => {
      const value = (event as CustomEvent).detail;
      if (value === "en" || value === "ar") setLocalLanguage(value as T);
    };
    const current = getAccountLanguage();
    if (current) setLocalLanguage(current as T);
    window.addEventListener(ACCOUNT_LANGUAGE_EVENT, apply);
    return () => window.removeEventListener(ACCOUNT_LANGUAGE_EVENT, apply);
  }, [setLocalLanguage]);
  return useCallback(
    (value: T) => {
      setLocalLanguage(value);
      if (getAccountLanguage() !== null)
        window.dispatchEvent(
          new CustomEvent("arabian:staff-language-choice", { detail: value }),
        );
    },
    [setLocalLanguage],
  );
}
